import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";

function Shops() {
  const navigate = useNavigate();
  const [shops, setShops] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const fetchShops = async () => {
      try {
        setLoading(true);

        const { data, error } = await supabase
          .from("shops")
          .select(`
            *,
            shop_owners (
              id,
              business_name,
              average_rating
            )
          `)
          .order("created_at", { ascending: false });

        if (error) throw error;

        setShops(data || []);
      } catch (error) {
        console.error("Fetch shops error:", error);
        setErrorMessage(error.message || "Failed to load shops.");
      } finally {
        setLoading(false);
      }
    };

    fetchShops();
  }, []);

  return (
    <div style={page}>
      <button onClick={() => navigate("/")} style={backBtn}>
        Back to Home
      </button>

      <div style={heroCard}>
        <h1 style={{ marginTop: 0 }}>Shops & Vendors</h1>
        <p style={{ color: "#d1d1d1", marginBottom: 0 }}>
          Browse real shop owners and material suppliers near you.
        </p>
      </div>

      {errorMessage && <div style={errorBox}>{errorMessage}</div>}

      {loading ? (
        <div style={card}>
          <p>Loading shops...</p>
        </div>
      ) : shops.length === 0 ? (
        <div style={card}>
          <p>No verified shops available right now.</p>
        </div>
      ) : (
        <div style={grid}>
          {shops.map((shop) => {
            const rating = Number(
              shop.rating || shop.shop_owners?.average_rating || 0
            ).toFixed(1);

            return (
              <div key={shop.id} style={card}>
                <h3 style={{ margin: "0 0 8px 0" }}>
                  {shop.shop_name || shop.shop_owners?.business_name || "Shop"}
                </h3>

                <p style={muted}><strong>Category:</strong> Material Supplier</p>
                <p style={muted}><strong>Location:</strong> {shop.city || "N/A"}</p>
                <p style={muted}>
                  <strong>Address:</strong>{" "}
                  {[shop.flat_house_no, shop.street_area, shop.city, shop.state]
                    .filter(Boolean)
                    .join(", ") || "N/A"}
                </p>
                <p style={muted}>
                  <strong>Rating:</strong> {rating} ⭐
                </p>
                <p style={muted}>
                  <strong>Delivery:</strong> Estimated at checkout
                </p>

                <button
                  onClick={() =>
                    navigate(`/vendor-details?shopId=${shop.id}`, {
                      state: { shop },
                    })
                  }
                  style={solidBtn}
                >
                  View Shop
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

const page = {
  padding: "40px",
  fontFamily: "Arial, sans-serif",
  maxWidth: "1100px",
  margin: "0 auto",
  background: "#000",
  color: "#fff",
  minHeight: "100vh",
};

const heroCard = {
  background: "linear-gradient(135deg, #111, #191919)",
  padding: "24px",
  borderRadius: "18px",
  border: "1px solid #2a2a2a",
  marginBottom: "24px",
};

const grid = {
  display: "grid",
  gap: "16px",
};

const card = {
  background: "#111",
  padding: "20px",
  borderRadius: "16px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.18)",
  border: "1px solid #222",
};

const backBtn = {
  marginBottom: "20px",
  padding: "10px 16px",
  border: "1px solid #444",
  background: "#111",
  color: "#fff",
  borderRadius: "10px",
  cursor: "pointer",
};

const solidBtn = {
  marginTop: "12px",
  padding: "10px 16px",
  background: "#fff",
  color: "#000",
  border: "none",
  borderRadius: "10px",
  cursor: "pointer",
  fontWeight: "bold",
};

const muted = {
  margin: "4px 0",
  color: "#d1d1d1",
};

const errorBox = {
  background: "#2a1111",
  color: "#ff9a9a",
  padding: "12px 16px",
  borderRadius: "10px",
  marginBottom: "16px",
};

export default Shops;
